import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';

import Hero from '@components/Hero/Hero';
import { MEDIA_QUERIES } from "@constants";

export const DEIHero = styled(Hero)`
  position: relative;
  
  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 800px;
    max-width: 100%;
    height: 500px;
    background: radial-gradient(circle at 0% -58%, #F2F6FF, rgba(255,0,0,0) 70.71%),
      radial-gradient(circle at 6.7% 75%, #ffffff, rgba(0,0,255,0) 70.71%),
      radial-gradient(circle at 93.3% 75%, #ffffff, rgba(0,255,0,0) 70.71%);

  }
`

export const DEIPageHeroDIV = styled.div`
  position: relative;
  margin-bottom: var(--spacing--XL);

  ${MEDIA_QUERIES.M} {
    padding-bottom: 120px;
  }

  p {
    color: var(--color--text-default);
    max-width: var(--text-max-width);
  }

`;

export const DEIPageHeroImgWrapperDIV = styled.div`
  display: none;
  position: absolute;
  bottom: -380px;
  left: 0;
  z-index: 0;
  width: 100vw;
  height: 1027px;
  overflow: hidden;

  ${MEDIA_QUERIES.M} {
    display: block;
  }
`;

export const DEIPageHeroIMG = styled(GatsbyImage)`
  position: absolute !important;
  left: 50%;
  z-index: 0;
  width: 1920px;
  transform: translateX(-50%);
`;

export const DEIPageMobileHeroIMG = styled(GatsbyImage)`
  position: absolute !important;
  bottom: 0;
  left: 0;
  width: 100%;

  ${MEDIA_QUERIES.M} {
    display: none !important;
  }
`;

export const DEIPageHeroContentDIV = styled.div`
  position: relative;
  z-index: 1;
  padding: 80px 0 calc(100vw * 0.35); /* Height of responsive ladder image */

  ${MEDIA_QUERIES.S} {
    width: 80%;
  }

  ${MEDIA_QUERIES.M} {
    width: 66.6666%;
    padding: 100px 0;
  }
`;
